import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-dismiss after 5 seconds
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Add fade-out animation
    this.element.classList.add("animate-toast-out")

    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
